import * as React from 'react';
export const getComponentName = (component) => {
    if (!React.isValidElement(component))
        return undefined;
    try {
        const type = component.type;
        return type.displayName || type.name || undefined;
    }
    catch { }
    return undefined;
};
